<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{alterar}} Convênio</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field v-model="convenio.nome" label="Nome" required></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                label="Cnpj"
                mask="##############"
                :rules="cnpjRules"
                counter="14"
                v-model="convenio.cnpj"
                hint="utiliza somente números"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-textarea v-model="convenio.descricao" name="descricao" label="Descrição" value></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Campos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" color="terciary" @click.native="parente()">Cancelar</v-btn>
        <v-btn
          class="white--text"
          color="sucesso"
          @click.native="convenio.id==''? salvar():atualizar()"
        >Gravar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";

var moment = require("moment");

export default {
  name: "FormCadConvenio",
  props: ["dialog", "dados"],
  mixins: [formata],

  data: () => ({
    convenio: {
      nome: "",
      cnpj: "",
      descricao: "",
      id: ""
    },

    alterar: "",
    cnpjRules: [
      v => !!v || "Cnpj é requerido",
      v => v.length == 14 || "Cnpj   Menor que o padrão"
    ]
  }),
  mounted() {
    //alert(this.dados);
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dados(val) {
      if (val) {
        this.convenio.nome = val.nome;
        this.convenio.cnpj = val.cnpj;
        this.convenio.descricao = val.descricao;
        this.convenio.id = val.id;
        this.alterar = "Alterar ";
      } else {
        this.convenio.id = "";
        this.alterar = "";
      }
    },
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    atualizar() {
      HTTP.put(`convenio/` + this.convenio.id, this.convenio)
        .then(response => {
          if (response.data.error) {
          }
          this.convenio.cnpj = "";
          this.convenio.nome = "";
          this.convenio.id = "";
          this.convenio.descricao = "";

          this.$emit("gravacaoOkConvenio");
          this.$emit("fechaDialog");
          this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          console.log(e.response.data.error);
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.$emit("getCadConvenio", itens.join(","));
          }
        });
      // this.$parent.selDialog = false;
    },
    salvar() {
      HTTP.post(`convenio`, this.convenio)
        .then(response => {
          if (response.data.error) {
            alert("erross:");
          }
          this.convenio.cnpj = "";
          this.convenio.nome = "";
          this.convenio.descricao = "";
          this.$emit("gravacaoOkConvenio");
          this.$emit("fechaDialog");
          this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          console.log(e.response.data.error);
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.$emit("getCadConvenio", itens.join(","));
          }
        });
      // this.$parent.selDialog = false;
    },
    parente() {
      this.$emit("fechaDialog");
    },

    checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaConvenios() {
      this.loading = true;
      HTTP.get(`grupo/lista/convenio`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =

          this.items = response.data;
          this.mostraCartoes = true;
        }
        this.loading = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormCadConvenio.vue